'use strict';
import SxQueryUtils from '../sxQuery/SxQueryUtils';
const entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const inverseEntityMap = Object.keys(entityMap).reduce((acc, key) => { acc[entityMap[key]] = key; return acc; }, {});
const highlightSearchWords = (string, searchString) => {
    if (string === undefined || searchString === undefined) {
        return string;
    }
    const words = searchString.replace(/[^a-zA-Z0-9äöüÄÖÜßçâêîôûàèùëïěščřžýáíéťňÇÂÊÎÔÛÀÈÙËÏĚŠČŘŽÝÁÍÉŤŇ]|\s+|\r?\n|\r/gmi, ' ')
        .replace(/[^a-zA-Z0-9äöüÄÖÜßçâêîôûàèùëïěščřžýáíéťňÇÂÊÎÔÛÀÈÙËÏĚŠČŘŽÝÁÍÉŤŇ]/g, ' ').split(' ');
    // sort words by length, longest first
    words.sort((a, b) => b.length - a.length);
    const markers = {};
    SxQueryUtils.each(words, (idx, word) => {
        if (word.length < 2) {
            return;
        }
        const matches = string.match(new RegExp(`((${word})(?!#<##|-\\d+#<##))(?!.*\\1)`, 'gi'));
        if (matches != null) {
            for (let i = 0; i < matches.length; i++) {
                const match = matches[i];
                const matchEsc = match.replace(/[-[\]/{}()*+?.^$|]/g, '\\$&');
                string = string.replace(new RegExp(`(${matchEsc})(?!#<##|-\\d+#<##)`, 'g'), `##>#${idx}-${i}#<##`);
                markers[`##>#${idx}-${i}#<##`] = `<span class="unibox__highlight">${match}</span>`;
            }
        }
    });
    const reversedMarkerKeys = Object.keys(markers).reverse();
    for (let i = 0; i < reversedMarkerKeys.length; i++) {
        const singleMarker = reversedMarkerKeys[i];
        const replacement = markers[singleMarker];
        string = string.replace(new RegExp(singleMarker, 'gi'), replacement);
    }
    return string;
};
const StringHelper = {
    escapeHtml(string) {
        return String(string).replace(/[&<>"'/]/g, (s) => entityMap[s]);
    },
    unescapeHtml(string) {
        string = String(string);
        Object.keys(inverseEntityMap).forEach((entity) => {
            string = string.replace(new RegExp(entity, 'g'), inverseEntityMap[entity]);
        });
        return string;
    },
    getSafeKey(key) {
        return (key.toString()).replace(/[ "§$%&/(){}+*,.;|:!]/g, '_').replace(/#/g, '__').replace(/'/g, '---').toLowerCase();
    },
    ensureSentenceEnd(text) {
        if (text === undefined || text === null || text.length === 0) {
            return text;
        }
        return /[.,!?:;…。！？]\s*$/.test(text) ? text : `${text}.`;
    },
    highlightSearchWords,
    sanitizeXss(value) {
        if (value === undefined || value === null || value.length === 0) {
            return value;
        }
        if (value.indexOf('<') === -1 && value.indexOf('>') === -1) {
            return /^\s*(javascript|data):/i.test(value) ? '' : value;
        }
        try {
            let wrapper;
            if ('DOMParser' in window) {
                const body = new DOMParser().parseFromString(`<div>${value}</div>`, 'text/html').body;
                wrapper = body.firstElementChild;
            }
            else {
                return '';
            }
            if (!wrapper) {
                return value;
            }
            const ALLOWED_TAGS = new Set(['a', 'b', 'br', 'em', 'i', 'li', 'ol', 'p', 'span', 'strong', 'u', 'ul', 'div']);
            const ALLOWED_ATTRS = new Set(['class', 'id', 'href', 'target', 'title']);
            const TRUSTED_SCRIPT_HOSTS = new Set(['api-tiger.zoovu.com', 'api-barracuda.zoovu.com', 'orca-api.zoovu.com', 'qa10-api.dev.zoovu.io']);
            const ALLOWED_SCRIPT_ATTRS = new Set(['src', 'type', 'async', 'defer']);
            const sanitizeNode = (el) => {
                let child = el.firstChild;
                while (child) {
                    if (child.nodeType !== Node.ELEMENT_NODE) {
                        child = child.nextSibling;
                        continue;
                    }
                    const childEl = child;
                    const next = child.nextSibling;
                    if (childEl.tagName.toLowerCase() === 'script') {
                        let trusted = false;
                        try {
                            trusted = TRUSTED_SCRIPT_HOSTS.has(new URL(childEl.getAttribute('src') || '').hostname);
                        }
                        catch (e) {
                            // invalid or relative URL — not trusted
                        }
                        if (!trusted) {
                            el.removeChild(childEl);
                        }
                        else {
                            Array.from(childEl.attributes).forEach(attr => {
                                if (!ALLOWED_SCRIPT_ATTRS.has(attr.name)) {
                                    childEl.removeAttribute(attr.name);
                                }
                            });
                        }
                        child = next;
                        continue;
                    }
                    if (!ALLOWED_TAGS.has(childEl.tagName.toLowerCase())) {
                        const firstPromoted = childEl.firstChild;
                        while (childEl.firstChild)
                            el.insertBefore(childEl.firstChild, childEl);
                        el.removeChild(childEl);
                        child = firstPromoted || next;
                    }
                    else {
                        Array.from(childEl.attributes).forEach(attr => {
                            if (!ALLOWED_ATTRS.has(attr.name) || (attr.name === 'href' && /^\s*(javascript|data):/i.test(attr.value))) {
                                childEl.removeAttribute(attr.name);
                            }
                        });
                        sanitizeNode(childEl);
                        child = next;
                    }
                }
            };
            sanitizeNode(wrapper);
            return wrapper.innerHTML;
        }
        catch (err) {
            console.error(err);
            return value;
        }
    }
};
export default StringHelper;
